import React from 'react'
import {Route, IndexRoute} from 'react-router'
import Layout from './Layout'
import Main from './Main'
import MySignDocuments from './MySignDocuments'
import OwnSignedDocuments from './OwnSignedDocuments'
import OwnPendingDocuments from './OwnPendingDocuments'
import ViewerDocuments from './ViewerDocuments'
import OwnArchivedDocuments from './OwnArchivedDocuments'
// import Drafts from './Drafts'
import MassiveUpload from './MassiveUpload'
import MassiveDactilar from './MassiveDactilar'
import MassiveFea from './MassiveFEA'
import Document from './Document'
import Preview from './Preview'
import FillNameFields from './FillNameFields'
import RejectedDocuments from './RejectedDocuments'
import FeaReadyDocuments from './FeaReadyDocuments'

export default (
  <Route path="/documents" component={Layout}>
    <IndexRoute component={Main} />
    <Route path="mysigndocuments" component={MySignDocuments} />
    <Route path="ownsigneddocuments" component={OwnSignedDocuments} />
    <Route path="feareadydocuments" component={FeaReadyDocuments} />
    <Route path="ownpendingdocuments" component={OwnPendingDocuments} />
    <Route path="viewerdocuments" component={ViewerDocuments} />
    <Route path="ownarchiveddocuments" component={OwnArchivedDocuments} />
    <Route path="rejecteddocuments" component={RejectedDocuments} />
    <Route path="massiveupload" component={MassiveUpload} />
    <Route path="massivedactilar" component={MassiveDactilar} />
    <Route path="massivefea" component={MassiveFea} />
    <Route path=":documentId" component={Document} />
    <Route path=":documentId/preview" component={Preview} />
    <Route path=":documentId/fillnamefields" component={FillNameFields} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/index.js